import React, { useState, useRef, useEffect } from 'react';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { useHistory } from 'react-router-dom';
import { Container, Grid, Paper } from '@material-ui/core';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import { LOGOUT } from 'ConstComponents';
import { AccountOpenGenerateURL } from 'Components/Api/PaysprintAccountOpeningAPI';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import Divider from '@material-ui/core/Divider';
import { PLEASE_SELECT_VALID } from 'Components/Helper/Messages';
import { ACCOUNT_OPENING_CODE } from 'Components/Helper/Messages';
import HOCLoader from 'Components/Loader/HOCLoader';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import {
    PrimaryButton,
    SecondaryButton
} from 'Components/Inputes/CustomButton';
import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
import PayIcon from 'Components/SvgButtons/PayIcon';
import AsyncOperatorAutoComplete from 'Components/Inputes/AsyncOperatorAutoComplete';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
const CustomContainer = HOCLoader(Container);

export const PaysprintAccountOpen = () => {
    const classes = commonStyle();
    const [responseMessage, setResponseMessage] = useState('');
    const history = useHistory();
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [confirmAlertMessage, setConfirmAlertMessage] = useState('');
    const [serviceCode, setserviceCode] = useState(ACCOUNT_OPENING_CODE);
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [ResponseAlert, setResponseAlert] = useState({});
    const [status, setStatus] = useState('PROCESS');
    const [Operator, setOperator] = useState([]);

    const formRef = useRef();
    const [OperatorDefault, setOperatorDefault] = useState({
        OperatorID: 0,
        OperatorName: 'Select Operator'
    });
    const initialValues = {
        ServiceID: ACCOUNT_OPENING_CODE,
        Operator: OperatorDefault
    };

    const [FormObj, setFormObj] = useState(initialValues);

    const FormValidationSchema = Yup.object({
        Operator: Yup.object()
            .nullable(PLEASE_SELECT_VALID + 'operator')
            .required(PLEASE_SELECT_VALID + 'operator')
            .shape({
                OperatorID: Yup.number()
                    .notOneOf([0], PLEASE_SELECT_VALID + 'operator')
                    .nullable(PLEASE_SELECT_VALID + 'operator')
                    .required(PLEASE_SELECT_VALID + 'operator')
            })
    });

    useEffect(() => {
        setLoading(true);
    }, []);

    useEffect(() => {
        setLoading(true);
        selectOperator(serviceCode);
    }, [serviceCode]);

    const selectOperator = async (ServiceID) => {
        if (
            ServiceID === null ||
            ServiceID === undefined ||
            ServiceID === 0 ||
            ServiceID === '0'
        )
            return;

        var requestObj = {
            ServiceID: ServiceID
        };

        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data !== 'Requested operators not found') {
            var data = JSON.parse(response.data);
            setOperator(data);
        }
    };

    const submitHandle = async (values) => {
        setResponseMessage('');
        setIsError(false);

        var RequestObj = {
            ServiceID: values.ServiceID,
            OperatorName: values.Operator.OperatorName,
            OperatorID: values.Operator.OperatorID
        };

        let msg = '';

        msg = `Please confirm Account type - \n\n : ${values.Operator.OperatorName}`;

        setConfirmAlertMessage(msg);
        setConfirmAlertRequest(RequestObj);
        setIsAlertOpen(true);
    };

    const OnOperatorChange = async (name, value, setFieldValue) => {
        setOperatorDefault({
            OperatorID: value.OperatorID,
            OperatorName: value.OperatorName
        });

        let OperatorID = value.OperatorID; //event.target.value;
        setFieldValue(name, value);
    };

    const AccountOpeningURL = async () => {
        setResponseMessage('');
        setIsError(false);

        var requestObj = JSON.stringify(confirmAlertRequest);

        setLoading(true);

        var response = await AccountOpenGenerateURL(requestObj);
        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        let dataSuccess = JSON.parse(response.data);

        setSeverity('success');

        let params = {
            RedirectURL: dataSuccess.URL
        };

        history.push('/PaysprintURLRedirect', params);

        reset();
    };

    const reset = () => {
        setOperatorDefault({
            OperatorID: 0,
            OperatorName: 'Select Operator'
        });
        setFormObj({
            ServiceID: ACCOUNT_OPENING_CODE,
            Operator: OperatorDefault,
            AccountNo: '',
            IFSC: '',
            Amount: '',
            UPIID: '',
            InWords: '',
            BeneName: ''
        });
    };

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={FormObj}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={FormObj}
            >
                {({ values, setFieldValue }) => {
                    return (
                        <Grid
                            item
                            container
                            margin="normal"
                            xs={12}
                            md={12}
                            sm={12}
                            lg={12}
                            spacing={2}
                        >
                            <Grid item xs={12} sm={12} md={4} lg={4}>
                                <Form>
                                    <Grid item xs={12} sm={12}>
                                        <Paper className={classes.PaperStyle}>
                                            <Grid container spacing={2}>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={12}
                                                    lg={12}
                                                >
                                                    <Field
                                                        component={
                                                            AsyncOperatorAutoComplete
                                                        }
                                                        defaultValue={
                                                            OperatorDefault
                                                        }
                                                        ImagePath={'Path'}
                                                        SubFieldName="OperatorID"
                                                        FieldName="Operator"
                                                        name="Operator"
                                                        options={Operator}
                                                        getOptionLabel={(
                                                            option
                                                        ) =>
                                                            option.OperatorName
                                                        }
                                                        getOptionSelected={(
                                                            option,
                                                            value
                                                        ) =>
                                                            option.OperatorName ===
                                                            value.OperatorName
                                                        }
                                                        textFieldProps={{
                                                            label:
                                                                'Select Operator'
                                                        }}
                                                        onCustomCallback={(
                                                            name,
                                                            value
                                                        ) => {
                                                            OnOperatorChange(
                                                                name,
                                                                value,
                                                                setFieldValue
                                                            );
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Divider
                                                variant="middle"
                                                className="rechdevider"
                                            />

                                            <Grid
                                                item
                                                xs={12}
                                                sm={12}
                                                md={12}
                                                lg={12}
                                                spacing={2}
                                                container
                                                className={classes.footerGrid}
                                            >
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                >
                                                    <SecondaryButton
                                                        type="reset"
                                                        variant="contained"
                                                        color="secondary"
                                                        title="Reset"
                                                        disabled={loading}
                                                        endIcon={<ResetIcon />}
                                                        onClick={(e) => reset()}
                                                    ></SecondaryButton>
                                                </Grid>
                                                <Grid
                                                    item
                                                    xs={12}
                                                    sm={12}
                                                    md={6}
                                                    lg={6}
                                                >
                                                    <PrimaryButton
                                                        type="submit"
                                                        title="Account Open"
                                                        endIcon={<PayIcon />}
                                                        disabled={loading}
                                                        onClick={(e) => {
                                                            setFieldValue(
                                                                'IsVerifyButton',
                                                                false
                                                            );
                                                        }}
                                                    ></PrimaryButton>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                </Form>
                            </Grid>
                        </Grid>
                    );
                }}
            </Formik>

            {isAlertOpen ? (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="Account Opening Confirmation"
                    message={confirmAlertMessage}
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        AccountOpeningURL(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}

            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    isPrint={true}
                    title={status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        setIsResponseAlertOpen(false);
                    }}
                    PrintButtonClick={() => {
                        setIsResponseAlertOpen(false);
                    }}
                />
            ) : null}
        </CustomContainer>
    );
};
